export default __webpack_public_path__ + "assets/images/f4836c4513e67d71d5e8aef633980e85.svg";